import dynamic from "next/dynamic";
const RegularReviewsComponent = dynamic(()=>import("./regular-reviews-component"));
import RegularReviewsConfig from "./regular-reviews-config";
import RegularReviewsAdvancedConfig from "./regular-reviews-advanced-config";
export default {
    RegularReviewsComponent,
    RegularReviewsConfig,
    RegularReviewsAdvancedConfig
};
